import React from 'react';
import objectivesData from '../data/objectives.json';

function Objectives() {
  const { hero, objectivesTitle, objectives, commitmentTitle, commitment } = objectivesData;

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      <div className="content-section container objectives-section">
        <h2>{objectivesTitle}</h2>
        <ol className="objectives-list">
          {objectives.map((objective) => (
            <li key={objective}>{objective}</li>
          ))}
        </ol>
      </div>

      <div className="content-section container">
        <h2>{commitmentTitle}</h2>
        <p className="objectives-commitment">
          {commitment}
        </p>
      </div>
    </div>
  );
}

export default Objectives;
